import { Button, List, ListItem, Paper, Popper, styled, Typography } from '@mui/material'

export const FilterSelectorContainer = styled('div')(({ theme }) => ({
  marginLeft: 'auto',
  position: 'relative',
  background: '#FFFFFF',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    padding: 0,
    margin: 0,
  },
}))

export const FilterSelectorButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  width: '100%',
  height: 48,
  padding: 0,
  minHeight: 32,
  background: 'none',
  borderBottom: '1px solid #c4c4c4',
  boxSizing: 'border-box',
  position: 'relative',
  fontSize: '16px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    position: 'absolute',
    right: 5,
  },
  '&.open': {
    borderBottom: '1px solid #000000',
    backgroundColor: 'transparent',
    '& .MuiSvgIcon-root': {
      color: '#000000',
      transform: 'rotate(180deg)',
    },
  },
  '& .MuiTypography-root:first-letter': {
    textTransform: 'capitalize',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
  [theme.breakpoints.down('xs')]: {
    margin: 0,
  },
}))

export const FilterSelectorCardLabel = styled(Typography)(({ theme }) => ({
  width: '100%',
  textAlign: 'start',
  padding: theme.spacing(2.5, 3, 1, 1.5),
  '& :first-letter': {
    textTransform: 'capitalize',
  },
}))

export const FilterSelectorPopper = styled(Popper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  padding: 0,
  width: '100%',
  left: 0,
  zIndex: theme.zIndex.drawer + 1,
}))

export const FilterSelectorPaper = styled(Paper)({
  position: 'absolute',
  width: '100%',
  maxHeight: '65vh',
  marginRight: 0,
  maxWidth: '100%',
  background: '#FFFFFF',
  borderRadius: 0,
  overflowX: 'hidden',
  boxShadow: '0 3.5px 14px rgba(0, 0, 0, 0.2)',
  '&::-webkit-scrollbar': {
    width: '0.5em',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.1)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    outline: '1px solid #efefef',
    borderRadius: '0.05em',
  },
})

export const FilterSelectorList = styled(List)({
  boxShadow: '5px 5px 4px 0px rgba(34, 60, 80, 0.2)',
  backgroundColor: 'white',
  '& :first-letter': {
    textTransform: 'capitalize',
  },
})

export const FilterSelectorListItem = styled(ListItem)(({ theme }) => ({
  '& .MuiTypography-displayBlock': {
    marginBottom: 0,
  },
  '& .MuiListItemIcon-root': {
    minWidth: '0.5em',
    marginRight: theme.spacing(2),
  },
  '& .flag-icon-lg': {
    fontSize: '0.8em',
  },
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'start',
  alignContent: 'start',
  paddingRight: theme.spacing(1.5),
  position: 'static',
  width: '100%',
  left: 0,
  top: theme.spacing(6),
  background: '#FFFFFF',
  marginTop: '5px',
  justifyContent: 'space-between',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
  },
}))
